// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`BidGroupVendorSpecQuoteItem Model belongsTo relations 1`] = `
Array [
  "BidGroupVendorSpecQuote",
  "Spec",
]
`;
